import { apiConstants } from '../../apiConstant'
import { formDataCommonFunction } from '../../serviceCall'

export const getSavedProjectSuggestionsApi = (data, callback, errorCallBack) => {
    return async (dispatch) => {
        formDataCommonFunction(data, apiConstants.TICKET.GET_SAVED_PROJECT_SUGGESTIONS)
            .then((response) => {
                callback && callback(response)
            })
            .catch((error) => {
                errorCallBack && errorCallBack(error.response)
            })
    }
} 
